import { createContext } from 'react';

export const CompanyContext = createContext({})
export const UserContext = createContext({})
export const FlowContext = createContext({})
export const ObligationsContext = createContext({})

// RulesContext is exported from RulesContext.jsx
export { useRules, RulesProvider } from './context/RulesContext';
export { EOAFContext, useEOAFContext } from './context/EOAFContext';